import React from 'react';

const Cookies = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <div className="container max-w-4xl mx-auto px-4 py-8">
        {/* Header */}
        <h1 className="text-4xl font-bold mb-4 text-gray-900 dark:text-white">
          Politique de Cookies
        </h1>

        <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">
          Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
        </p>

        {/* Introduction */}
        <section className="mb-8">
          <div className="bg-blue-50 dark:bg-blue-900/20 border-l-4 border-blue-500 p-6 rounded">
            <h2 className="text-xl font-semibold mb-3 text-gray-900 dark:text-white">
              Qu'est-ce qu'un cookie ?
            </h2>
            <p className="leading-relaxed text-gray-700 dark:text-gray-300">
              Un cookie est un petit fichier texte stocké sur votre appareil (ordinateur,
              smartphone, tablette) lors de votre visite sur un site web. Les cookies permettent au
              site de reconnaître votre appareil et de mémoriser certaines informations sur vos
              préférences ou actions.
            </p>
          </div>
        </section>

        {/* Types de cookies */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Types de cookies utilisés sur Remadia Health{' '}
          </h2>

          {/* Cookies essentiels */}
          <div className="mb-6">
            <h3 className="text-xl font-semibold mb-3 text-gray-800 dark:text-gray-200">
              🔒 Cookies strictement nécessaires
            </h3>
            <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
              <p className="mb-3 text-gray-700 dark:text-gray-300">
                Ces cookies sont indispensables au fonctionnement du site. Ils ne peuvent pas être
                désactivés.
              </p>
              <table className="w-full text-sm">
                <thead className="bg-gray-200 dark:bg-gray-700">
                  <tr>
                    <th className="p-2 text-left text-gray-900 dark:text-white">Nom</th>
                    <th className="p-2 text-left text-gray-900 dark:text-white">Finalité</th>
                    <th className="p-2 text-left text-gray-900 dark:text-white">Durée</th>
                  </tr>
                </thead>
                <tbody className="text-gray-700 dark:text-gray-300">
                  <tr className="border-b border-gray-200 dark:border-gray-600">
                    <td className="p-2">firebase-auth</td>
                    <td className="p-2">Authentification utilisateur</td>
                    <td className="p-2">Session</td>
                  </tr>
                  <tr className="border-b border-gray-200 dark:border-gray-600">
                    <td className="p-2">session-id</td>
                    <td className="p-2">Maintien de la session</td>
                    <td className="p-2">1 heure</td>
                  </tr>
                  <tr>
                    <td className="p-2">dark-mode</td>
                    <td className="p-2">Préférence thème sombre/clair</td>
                    <td className="p-2">1 an</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Cookies de fonctionnalité */}
          <div className="mb-6">
            <h3 className="text-xl font-semibold mb-3 text-gray-800 dark:text-gray-200">
              ⚙️ Cookies de fonctionnalité
            </h3>
            <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
              <p className="mb-3 text-gray-700 dark:text-gray-300">
                Ces cookies permettent d'améliorer votre expérience en mémorisant vos préférences.
              </p>
              <table className="w-full text-sm">
                <thead className="bg-gray-200 dark:bg-gray-700">
                  <tr>
                    <th className="p-2 text-left text-gray-900 dark:text-white">Nom</th>
                    <th className="p-2 text-left text-gray-900 dark:text-white">Finalité</th>
                    <th className="p-2 text-left text-gray-900 dark:text-white">Durée</th>
                  </tr>
                </thead>
                <tbody className="text-gray-700 dark:text-gray-300">
                  <tr className="border-b border-gray-200 dark:border-gray-600">
                    <td className="p-2">health-data-consent</td>
                    <td className="p-2">Consentement traitement données de santé</td>
                    <td className="p-2">1 an</td>
                  </tr>
                  <tr className="border-b border-gray-200 dark:border-gray-600">
                    <td className="p-2">user-profile-type</td>
                    <td className="p-2">Type de profil (non_medical, infirmier, médecin)</td>
                    <td className="p-2">1 an</td>
                  </tr>
                  <tr className="border-b border-gray-200 dark:border-gray-600">
                    <td className="p-2">language</td>
                    <td className="p-2">Langue préférée</td>
                    <td className="p-2">1 an</td>
                  </tr>
                  <tr>
                    <td className="p-2">cookie-consent</td>
                    <td className="p-2">Enregistrement de votre choix cookies</td>
                    <td className="p-2">1 an</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Cookies analytiques */}
          <div className="mb-6">
            <h3 className="text-xl font-semibold mb-3 text-gray-800 dark:text-gray-200">
              📊 Cookies analytiques (optionnels)
            </h3>
            <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
              <p className="mb-3 text-gray-700 dark:text-gray-300">
                Ces cookies nous aident à comprendre comment vous utilisez le site pour l'améliorer.
                <strong> Ils nécessitent votre consentement.</strong>
              </p>
              <table className="w-full text-sm">
                <thead className="bg-gray-200 dark:bg-gray-700">
                  <tr>
                    <th className="p-2 text-left text-gray-900 dark:text-white">Service</th>
                    <th className="p-2 text-left text-gray-900 dark:text-white">Finalité</th>
                    <th className="p-2 text-left text-gray-900 dark:text-white">Durée</th>
                  </tr>
                </thead>
                <tbody className="text-gray-700 dark:text-gray-300">
                  <tr>
                    <td className="p-2">Analytics (anonymisé)</td>
                    <td className="p-2">Statistiques de visite, pages consultées</td>
                    <td className="p-2">13 mois</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* Consentement */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Votre consentement
          </h2>
          <div className="bg-yellow-50 dark:bg-yellow-900/20 p-6 rounded-lg text-gray-700 dark:text-gray-300">
            <p className="leading-relaxed mb-4">
              Lors de votre première visite, un bandeau vous demande votre consentement pour les
              cookies non essentiels (analytiques).
            </p>
            <p className="leading-relaxed mb-4">Vous pouvez à tout moment :</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Accepter tous les cookies</li>
              <li>Refuser les cookies non essentiels</li>
              <li>Modifier vos préférences ultérieurement</li>
            </ul>
          </div>
        </section>

        {/* Gestion des cookies */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Comment gérer vos cookies ?
          </h2>

          <div className="space-y-6">
            {/* Via le site */}
            <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-lg">
              <h3 className="font-semibold mb-3 text-gray-900 dark:text-white">
                1. Via Remadia Health
              </h3>
              <p className="text-gray-700 dark:text-gray-300">
                Vous pouvez modifier vos préférences cookies en cliquant sur le lien "Gérer les
                cookies" en bas de page, ou en supprimant le cookie "cookie-consent" pour réafficher
                le bandeau.
              </p>
            </div>

            {/* Via le navigateur */}
            <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
              <h3 className="font-semibold mb-3 text-gray-900 dark:text-white">
                2. Via votre navigateur
              </h3>
              <p className="mb-3 text-gray-700 dark:text-gray-300">
                Vous pouvez configurer votre navigateur pour bloquer ou supprimer les cookies :
              </p>
              <ul className="space-y-2 text-gray-700 dark:text-gray-300">
                <li>
                  <strong>Chrome :</strong> Paramètres → Confidentialité et sécurité → Cookies
                </li>
                <li>
                  <strong>Firefox :</strong> Paramètres → Vie privée et sécurité → Cookies et
                  données
                </li>
                <li>
                  <strong>Safari :</strong> Préférences → Confidentialité → Cookies
                </li>
                <li>
                  <strong>Edge :</strong> Paramètres → Cookies et autorisations de site
                </li>
              </ul>
              <p className="mt-4 text-sm text-gray-600 dark:text-gray-400">
                ⚠️ Attention : Bloquer tous les cookies peut empêcher certaines fonctionnalités du
                site de fonctionner correctement (notamment l'authentification).
              </p>
            </div>
          </div>
        </section>

        {/* Cookies tiers */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Cookies tiers
          </h2>
          <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg text-gray-700 dark:text-gray-300">
            <p className="leading-relaxed mb-4">
              Remadia Health utilise des services tiers qui peuvent déposer leurs propres cookies :
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>
                <strong>Google Firebase :</strong> Authentification et stockage de données (cookies
                essentiels)
              </li>
              <li>
                <strong>Firebase Hosting :</strong> Hébergement et performance (cookies essentiels)
              </li>
            </ul>
            <p className="mt-4 leading-relaxed">
              Ces services ont leurs propres politiques de confidentialité que nous vous
              encourageons à consulter.
            </p>
          </div>
        </section>

        {/* Durée de conservation */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Durée de conservation
          </h2>
          <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg">
            <table className="w-full text-sm text-gray-700 dark:text-gray-300">
              <thead className="bg-gray-200 dark:bg-gray-700">
                <tr>
                  <th className="p-2 text-left text-gray-900 dark:text-white">Type de cookie</th>
                  <th className="p-2 text-left text-gray-900 dark:text-white">Durée maximale</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-200 dark:border-gray-600">
                  <td className="p-2">Cookies de session</td>
                  <td className="p-2">Supprimés à la fermeture du navigateur</td>
                </tr>
                <tr className="border-b border-gray-200 dark:border-gray-600">
                  <td className="p-2">Cookies de fonctionnalité</td>
                  <td className="p-2">1 an</td>
                </tr>
                <tr>
                  <td className="p-2">Cookies analytiques</td>
                  <td className="p-2">13 mois</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Modifications */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Modifications de cette politique
          </h2>
          <p className="leading-relaxed text-gray-700 dark:text-gray-300">
            Nous pouvons modifier cette politique de cookies à tout moment. La date de dernière mise
            à jour est indiquée en haut de la page. Nous vous encourageons à consulter régulièrement
            cette page.
          </p>
        </section>

        {/* Contact */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Questions ?
          </h2>
          <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-lg text-gray-700 dark:text-gray-300">
            <p className="mb-2">Pour toute question concernant notre politique de cookies :</p>
            <p>
              <strong>Email :</strong> contact@remadia.com
            </p>
          </div>
        </section>

        {/* Bouton gestion */}
        <div className="mt-12 text-center">
          <button
            onClick={() => {
              localStorage.removeItem('cookieConsent');
              window.location.reload();
            }}
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg 
                       transition duration-200"
          >
            Modifier mes préférences cookies
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cookies;
